import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export function RedirectIfAuth({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const [params] = useSearchParams();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (session) {
    // Honor a same-origin return path (e.g. a share-link /join redeem) so a
    // signed-in user is not bounced to the dashboard mid-flow. Never an open
    // redirect to another host.
    const next = params.get("next");
    const dest = next && next.startsWith("/") && !next.startsWith("//") ? next : "/dashboard";
    return <Navigate to={dest} replace />;
  }

  return <>{children}</>;
}
